import { render, staticRenderFns } from "./RtnInvoiceRelated_Row.vue?vue&type=template&id=24c90a38&"
import script from "./RtnInvoiceRelated_Row.vue?vue&type=script&lang=js&"
export * from "./RtnInvoiceRelated_Row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports